// extracted by mini-css-extract-plugin
module.exports = {"copyImg":"CommandCopy-module--copyImg--3fb2x","pointer":"CommandCopy-module--pointer--1ZsBy"};